import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import axios from "axios";
import { Toasts } from "../toasts";
import { ModalGestionDeudaMina } from "./modalGestionDeudaMina";

const TablaActualizarDeudaMina = () => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accclaseproducc = JSON.parse(localStorage.getItem("accclaseproducc"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "codigoclase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          RIF
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          NOMBRE / RAZÓN SOCIAL
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const txtBuscador = useRef();
  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [agente, setAgente] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    const campos = "*";
    const nomtab = "agente";
    const nomid = "idtipoagente";
    const nomid2 = "mina";
    const orden = "idagente";

    const endpoint = `${
      op.conexion
    }/api/consulta/idsstring2rows?&campos=${campos}&id=${5}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${true}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscador.current.focus();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/agente/veragente/${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setAgente(response.data);
            setMostrar2(true);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const gestionar = (id) => (e) => {
    SeleccionarRegistro(id);
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
  }, []);

  return (
    <div className="p-0">
      <div className="container col-md-12 py-4">
        <div className="row col-md-10 m-0 mx-auto py-4">
          <div className="col-md-12">
            <div className="row col-md-12 py-2 d-flex justify-content-between">
              <input
                type="text"
                className=" col-2 form-control form-control-sm rounded-pill"
                ref={txtBuscador}
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
          </div>
          <div className="col-md-12" style={{ margin: "auto" }}>
            <TblContainer>
              <TblHead />

              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        {item.idagente}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        {item.rif}
                      </TableCell>
                      <TableCell style={{ textAlign: "start", width: "250px" }}>
                        {item.nombre}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "50px" }}>
                        <button
                          onClick={gestionar(item.idagente)}
                          className={
                            accclaseproducc.substring(0, 1) === "0"
                              ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                              : "btn btn-sm  btn-info rounded-pill ml-2"
                          }
                        >
                          <i className="fas fa-eye"> Actualizar</i>
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>

          <ModalGestionDeudaMina
            show={mostrar2}
            agente={agente}
            onHide={handleCancela2}
          />

          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
        </div>
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaActualizarDeudaMina;



// WEBPACK FOOTER //
// ./src/components/minas/tablaActualizaDeudaMina.js